import React from "react";
import ReactApexChart from "react-apexcharts";
import { Row, Card, CardHeader, CardBody } from "reactstrap";

const RevenueCoversChart = ({ mealPeriod, breakDownData, loading }) => {
  const categories = mealPeriod || ["Morning", "Afternoon", "Evening", "Night"];
  let series = [];
  let barSeries = [];
  let lineSeries = [];


  if (breakDownData.length > 0) {
    const cleanedBreakDownData = breakDownData.filter(
      (item) => item.name?.trim() !== ""
    );
    barSeries = cleanedBreakDownData.map((item) => ({
      name: `${item.name} Revenue`,
      type: "bar",
      data: item.revenue_data.map(Number),
      yAxisIndex: 0,
    }));

    lineSeries = cleanedBreakDownData.map((item) => ({
      name: `${item.name} Covers`,
      type: "line",
      data: item.covers_data.map(Number),
      yAxisIndex: 1,
    }));

    series = [...barSeries, ...lineSeries];
  }

  const options = {
    chart: {
      type: "line",
      stacked: false,
      toolbar: { show: true },
    },
    stroke: {
      width: [0, 0, 0, 3, 3, 3],
      curve: "smooth",
    },
    plotOptions: {
      bar: { columnWidth: "50%" },
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [3, 4, 5]
    },
    xaxis: {
      categories,
    },
    yaxis: [
      {
        seriesName: "Revenue",
        title: {
          text: "Resident Revenue",
          style: { color: "#96CEB4" },
        },
        labels: {
          formatter: (val) => `$${val}`,
          style: { color: "#96CEB4" },
        },
        axisBorder: { show: true, color: "#96CEB4" },
        axisTicks: { show: true, color: "#96CEB4" },
      },
      {
        seriesName: "Revenue",
        opposite: false,
        title: {
          text: "Non Resident Revenue",
          style: { color: "#45B7D1" },
        },
        labels: {
          formatter: (val) => `$${val}`,
          style: { color: "#45B7D1" },
        },
        axisBorder: { show: true, color: "#45B7D1" },
        axisTicks: { show: true, color: "#45B7D1" },
      },
      {
        seriesName: "Revenue",
        opposite: false,
        title: {
          text: "Take Away Revenue",
          style: { color: "#4ECDC4" },
        },
        labels: {
          formatter: (val) => `$${val}`,
          style: { color: "#4ECDC4" },
        },
        axisBorder: { show: true, color: "#4ECDC4" },
        axisTicks: { show: true, color: "#4ECDC4" },
      },
      {
        seriesName: "Covers",
        opposite: true,
        title: {
          text: "Covers",
          style: { color: "#FF5722" },
        },
        labels: {
          formatter: (val) => `${val}`,
          style: { color: "#FF5722" },
        },
        axisBorder: { show: true, color: "#FF5722" },
        axisTicks: { show: true, color: "#FF5722" },
      },
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (value, { seriesIndex }) => {
          if (seriesIndex < barSeries.length) {
            return `$${value.toFixed(2)}`;
          } else {
            return `${value} covers`;
          }
        },
      },
    },
    legend: {
      position: "bottom",
    },
    colors: ["#96CEB4", "#45B7D1", "#4ECDC4", "#FF6B6B", "#FF9F40", "#9966FF"],

  };

  return (
    <Row>
      <Card>
        <CardHeader className="ps-0 border-0 align-items-center d-flex">
          <div className="d-flex align-items-start">
            <div className={`icon-box rounded bg-danger text-white`}>
              <i className="ri-bar-chart-fill"></i>
            </div>
            <div className="ps-2">
              <h4 className="card-title mb-0 flex-grow-1">
                Revenue & Covers by Time Slot
              </h4>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <ReactApexChart
            options={options}
            series={series}
            type="line" // Mixed chart
            height={400}
          />
        </CardBody>
      </Card>
    </Row>
  );
};

export default RevenueCoversChart;
